import React, {useState} from "react";
import './AnalizaMain.css';

export default function Aplikacja(){

    return(
        <div className='conceptsContainer'>
            <h4>Nagranie z ekranu aplikacja <b>MatmaGO</b>.</h4>
            <br/><br/><br/>

            <iframe width="560" height="315" src="https://www.youtube.com/embed/whbdwUfPN4M"
                    title="YouTube video player" frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen></iframe>

            <br/><br/><br/>
        </div>
    );
}